import { createSvgIcon } from "@mui/material/utils";

export const Notification = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M8.62457 17.2C9.18867 17.6979 9.92967 18 10.7412 18C11.5528 18 12.2938 17.6979 12.8579 17.2M15.5412 6.8C15.5412 5.52696 15.0355 4.30606 14.1353 3.40589C13.2352 2.50571 12.0143 2 10.7412 2C9.46819 2 8.24729 2.50571 7.34711 3.40589C6.44694 4.30606 5.94123 5.52696 5.94123 6.8C5.94123 9.27215 5.3176 10.9648 4.62096 12.0843C4.03333 13.0287 3.73951 13.5009 3.75029 13.6326C3.76221 13.7785 3.79311 13.8341 3.91065 13.9213C4.01679 14 4.4953 14 5.45231 14H16.0301C16.9872 14 17.4657 14 17.5718 13.9213C17.6893 13.8341 17.7202 13.7785 17.7322 13.6326C17.7429 13.5009 17.4491 13.0287 16.8615 12.0843C16.1649 10.9648 15.5412 9.27215 15.5412 6.8Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Notification",
);
